import { AnalyticEventRecord, analyticEventFromJSON } from "common/records/AnalyticEvent";
import { AnalyticsReportDataRecord } from "common/records/AnalyticsReport";
import { AnalyticsUserRecord } from "common/records/AnalyticsUser";
import { RootActions, RootState } from "common/reducers";
import {
  RECEIVE_ANALYTIC_EVENT,
  RECEIVE_ANALYTIC_EVENTS,
  FETCH_ANALYTICS_REPORT,
  RECEIVE_ANALYTICS_REPORTS,
  SET_ANALYTICS_REPORT_LOADED,
  CLEAR_ANALYTICS_REPORTS,
  FETCH_ANALYTICS_USER,
  RECEIVE_ANALYTICS_USER,
  SET_ANALYTICS_USER_FAILED,
  CLEAR_ANALYTICS_USERS,
} from "common/reducers/analytics.actions";
import { List, Map, Record } from "immutable";
import { receive } from "common/reducers/Utils";

export const AnalyticsStateRecord = Record({
  // Analytics Events (History)
  byId: Map<number, AnalyticEventRecord>(),
  // Analytics Reports
  reports: List<AnalyticsReportDataRecord>(),
  reportsLoading: false,
  // Users for Analytics (separate from main user state, cleared on unmount)
  usersById: Map<number, AnalyticsUserRecord>(),
});

export const initialState = AnalyticsStateRecord();
export type AnalyticsState = typeof initialState;
export const model = "analytics";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    // Analytics Events (History)
    case RECEIVE_ANALYTIC_EVENT: {
      return receive(state, model, analyticEventFromJSON(action.payload.analyticEvent));
    }

    case RECEIVE_ANALYTIC_EVENTS:
      action.payload.analyticEvents.forEach((event) => {
        state = receive(state, model, analyticEventFromJSON(event));
      });
      return state;

    // Analytics Reports
    case FETCH_ANALYTICS_REPORT:
      return state.setIn([model, "reportsLoading"], true);

    case RECEIVE_ANALYTICS_REPORTS:
      return state.setIn([model, "reports"], action.payload.reports).setIn([model, "reportsLoading"], false);

    case SET_ANALYTICS_REPORT_LOADED:
      return state.setIn([model, "reportsLoading"], false);

    case CLEAR_ANALYTICS_REPORTS:
      return state.setIn([model, "reports"], List()).setIn([model, "reportsLoading"], false);

    // Analytics Users
    case FETCH_ANALYTICS_USER:
      return state.setIn([model, "usersById", action.payload.userId, "loading"], true);

    case RECEIVE_ANALYTICS_USER:
      return state.setIn([model, "usersById", action.payload.userId], action.payload.user);

    case SET_ANALYTICS_USER_FAILED:
      return state.setIn([model, "usersById", action.payload.userId], action.payload.user);

    case CLEAR_ANALYTICS_USERS:
      return state.setIn([model, "usersById"], Map());

    default:
      return state;
  }
};
